export interface ListedStyle {
    version: number;
    name: string;
    created: string;
    id: string;
    modified: string;
    owner: string;
    sources: Record<string, any>;
}

export interface Style {
    id: string;
    type: string;
    paint: any; // todo
    source: string;
    layers: {
        id: string;
        type: string;
        source: string;
        'source-layer': string;
    }[];
}

//Used in maps to download tiles
export const mapboxAccessTokenPk = 'pk.eyJ1IjoibWV0b2NlYW4iLCJhIjoia1hXZjVfSSJ9.rQPq6XLE0VhVPtcD9Cfw6A';

// Limited auth scope, only priviledge is ability to list the metocean account for mapbox styles.
export const mapboxAccessTokenSk = 'sk.eyJ1IjoibWV0b2NlYW4iLCJhIjoiY2wxb2FvaTRvMGlzMzNqbW9oNjNmY21mMCJ9.cYomh0NMls6AbZeV95_ARQ';

export const getStyles = async () => {
    const response = await fetch(`https://api.mapbox.com/styles/v1/metocean?access_token=${mapboxAccessTokenSk}`);
    const styles: ListedStyle[] = await response.json();
    return styles.filter((style) => style.name.startsWith('plat_') || style.name.startsWith('test_') || style.name.startsWith('uat_'));
};

export const getStyle = async (styleId: string) => {
    const response = await fetch(`https://api.mapbox.com/styles/v1/metocean/${styleId}?access_token=${mapboxAccessTokenSk}`);
    const style: Style = await response.json();
    return style;
};
